export interface LineTableBasicPropConfigSchema {
  baseURL: string | '';
  cartURL?: string | '';
  storyBlokURL?: string | '';
}
export class LineTableBasicPropConfig {
  private static instance: LineTableBasicPropConfig;

  config: LineTableBasicPropConfigSchema = {
    baseURL: '',
    cartURL: '',
    storyBlokURL: ''
  };

  private constructor(p_config: LineTableBasicPropConfigSchema) {
    this.config = p_config;
  }
  getConfig = () => {
    return this.config;
  };

  getBaseUrl = () => {
    return this.config?.baseURL ?? '';
  };

  getCartUrl = () => {
    return this.config?.cartURL ?? '';
  };

  getSBUrl = () => {
    return this.config?.storyBlokURL ?? '';
  };
//  commented for future purpose
  // isDevelopment = () => {
  //   return false;
  // };

  // getAuthDetials = (resource: string): string => {
  //   // const d: any = APIKeys[resource];
  //   const d: any = '';
  //   const encodedBase64Token = Buffer.from(`${d.key}:${d.apiValue}`).toString('base64');
  //   const authorization = `Basic ${encodedBase64Token}`;
  //   return authorization;
  // };

  public static getInstance = (): LineTableBasicPropConfig => {
    return LineTableBasicPropConfig.instance;
  };
  public static create = (p_config: LineTableBasicPropConfigSchema): void => {
    LineTableBasicPropConfig.instance = new LineTableBasicPropConfig(p_config);
  };
}

export interface AssetPathPropConfigSchema {
  assetPath: string | '';
  basicConfigUrl?: string | '';
}

export class AssetPathPropConfig {
  private static instance: AssetPathPropConfig;

  config: AssetPathPropConfigSchema = {
    assetPath: '',
    basicConfigUrl: ''
  };

  private constructor(path_config: AssetPathPropConfigSchema) {
    this.config = path_config;
  }

  getAssetPath = () => {
    return this.config?.assetPath ?? '';
  };

  getBasicConfigUrl = () => {
    return this.config?.basicConfigUrl ?? '';
  };

  public static getInstance = (): AssetPathPropConfig => {
    return AssetPathPropConfig.instance;
  };

  public static create = (path_config: AssetPathPropConfigSchema): void => {
    AssetPathPropConfig.instance = new AssetPathPropConfig(path_config);
  };
}
